import styled from 'styled-components';

const PrivacyPolicyStyle = styled.section`
    .section {
        max-width: 1440px;
    }
    
    .text-center {
        text-align: center;
    }
    
    ul {
        margin-left: 1rem;
        margin-top: 0.5rem;
        
        li {
            margin-top: 0.5rem;
            list-style: disc;
        }
    }
    
    .m {
        &-t-1 {
            margin-top: 1rem;
        }
        &-t-2 {
            margin-top: 2rem;
        }
        &-t-3 {
            margin-top: 3rem;
        }
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
        
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
        
    }

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
       
    }
`;

export default PrivacyPolicyStyle;
